import { render, staticRenderFns } from "./certificationPassed.vue?vue&type=template&id=2e6e6a6a&scoped=true&"
import script from "./certificationPassed.vue?vue&type=script&lang=js&"
export * from "./certificationPassed.vue?vue&type=script&lang=js&"
import style0 from "./certificationPassed.vue?vue&type=style&index=0&id=2e6e6a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e6a6a",
  null
  
)

export default component.exports